import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconUnorderedListStyle0 = gravityIconIndividualCss;

const GravityIconUnorderedList = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: 'cb0c2c99bafbdfbb6f76cb3653f154a0cac88bb4', color: this.color, size: this.size }, h("svg", { key: '0e240ff899c783713401be2d4edbd4b51c0df5cc', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '61502a2186f6f7d0b2e3a7f6a975cac02f144839', d: "M4.26 7a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Zm0 5.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Zm1.25 4a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Zm1.99-6a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5h-11ZM7 5.5a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 .5.5V6a.5.5 0 0 1-.5.5h-11A.5.5 0 0 1 7 6v-.5Zm.5 10a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5V16a.5.5 0 0 0-.5-.5h-11Z", fill: "currentColor" }))));
    }
};
GravityIconUnorderedList.style = GravityIconUnorderedListStyle0;

export { GravityIconUnorderedList as gravity_icon_unordered_list };

//# sourceMappingURL=gravity-icon-unordered-list.entry.js.map